const LABEL = {
  LOGIN: 'Area Riservata',
  CREATE_DONATION: 'Crea Raccolta',
  LOGOUT: 'Esci',
  GO_BACK: 'Indietro',
  HOME_HEADER: `Donare il sangue è un **gesto semplice**\nche può **salvare la vita** a molte persone.\n**Prenota la tua donazione!**`,
  HOME_MODAL_TITLE: 'PORTALE DI PRENOTAZIONE\nAVIS COMUNALE GENOVA\n',
  HOME_MODAL_SUBTITLE: 'Compila tutti i campi per procedere con la tua prenotazione.',
  LOGIN_HEADER: `**Benvenuto!**\nSei un operatore? Accedi per entrare\nnell'area riservata`,
  FORGOT_HEADER: `**Cambio Password**\nInserisci nome utente e\nnuova password`,
  LOGIN_LABEL: `LOGIN`,
  FORGOT_LABEL: `CAMBIO PASSWORD`,
  LOGIN_FORGOT_PASSWORD: `Password dimenticata?`,
  ADMIN_LOGIN_HEADER: `**Area Amministratori!**\nSei un amministratore? Accedi per entrare\nnell'area riservata`,
  ADMIN_CREATE_OPERATOR: `Crea Operatore`,
  ADMIN_CREATE_OPERATOR_DESCRIPTION: `**Crea Operatore**\nInserisci nome utente e\nseleziona una sezione`,
  NEW_DONATION: 'Nuova Raccolta',
  DETAIL_DONATION: 'Dettaglio Raccolta',
  EVENT: 'Evento',
  EVENT_DATA: 'Dati',
  EVENT_HOURS: 'Orari',

}

export default LABEL
